import { WizardFlowType } from '../@types/wizardFlowType'
import { RealEstateType } from '../@types/realEstateType'

export const getIsPdfWordingEnabled = (wizardFlowType: WizardFlowType, realEstateType = RealEstateType.HOUSE) =>
  wizardFlowType === WizardFlowType.IBW &&
  (realEstateType === RealEstateType.HOUSE || realEstateType === RealEstateType.APARTMENT)
